const NO_DATA_MARKER = { __noData: true };
const quotaWarningKeys = new Set();

export const readCache = (key, ttlMs) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.timestamp) return null;
    if (typeof ttlMs === 'number') {
      const isExpired = Date.now() - parsed.timestamp > ttlMs;
      if (isExpired) {
        localStorage.removeItem(key);
        return null;
      }
    }
    return parsed.data;
  } catch (err) {
    console.warn('Cache read failed:', err);
    return null;
  }
};

export const writeCache = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ timestamp: Date.now(), data }));
    return true;
  } catch (err) {
    const isQuotaError = err?.name === 'QuotaExceededError' || err?.code === 22 || err?.code === 1014;

    if (isQuotaError) {
      if (!quotaWarningKeys.has(key)) {
        quotaWarningKeys.add(key);
        console.warn(`Cache write skipped for ${key}: storage quota exceeded.`);
      }
    } else {
      console.warn(`Cache write failed for ${key}: ${err?.message || 'unknown error'}`);
    }

    return false;
  }
};

export const writeNoDataCache = (key) => writeCache(key, NO_DATA_MARKER);

export const isNoDataCache = (data) => Boolean(data && data.__noData);

export const clearCacheByPrefix = (prefix, options = {}) => {
  const { excludeKeys = [] } = options;
  try {
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith(prefix) && !excludeKeys.includes(key)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch (err) {
    console.warn('Cache clear failed:', err);
  }
};
